import { useEffect, useState } from 'react';
import { FaUpload, FaCheck, FaSpinner, FaArrowLeft, FaUserPlus, FaFileMedical } from 'react-icons/fa';
import { BsLightningCharge } from 'react-icons/bs';
import TableCheck from '../TableCheck';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import { createClient } from '@supabase/supabase-js';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Variantes de animación para elementos
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.07
    }
  }
};

const buttonVariants = {
  hover: { scale: 1.05 },
  tap: { scale: 0.95 }
};

export const mockValidationData = {
  "claim_data": {
    "bank": "Banco Santander, S.A.",
    "dni": "27310909L",
    "expenses": [
      {
        "amount": "480.75",
        "type": "notario_total"
      },
      {
        "amount": "240.38",
        "percentage": "50",
        "type": "notario"
      },
      {
        "amount": "209.99",
        "type": "gestoría"
      },
      {
        "amount": "90.91",
        "type": "registro"
      },
      {
        "amount": "214.99",
        "type": "tasación"
      }
    ],
    "name": "Jaime Gómez Vega",
    "protocol": "688"
  },
  "expense_docs": {
    "agency": {
      "checks": {
        "check_amount": "false",
        "check_nombre": "true",
        "check_protocolo": "No disponible"
      },
      "extraido": {
        "client_name": "Jaime Gomez Vega",
        "gestoria_amount": "419.99",
        "protocolo": "No disponible"
      },
      "recibido": {
        "client_name": "Jaime Gómez Vega",
        "gestoria_amount": "209.99",
        "protocol": "688"
      }
    },
    "appraisal": {
      "checks": {
        "check_amount": "true",
        "check_nombre": "true",
        "check_protocolo": "No disponible"
      },
      "extraido": {
        "appraisal_amount": "214.99",
        "client_name": "Jaime Gómez Vega",
        "protocolo": "No disponible"
      },
      "recibido": {
        "appraisal_amount": "214.99",
        "client_name": "Jaime Gómez Vega",
        "protocol": "688"
      }
    },
    "dni": {
      "checks": {
        "check_dni": "true",
        "check_nombre": "true",
        "dni_valido": "true"
      },
      "extraido": {
        "client_dni": "27310909L",
        "client_dni_valido": "true",
        "client_name": "Jaime Gomez Vega"
      },
      "recibido": {
        "client_dni": "27310909L",
        "client_name": "Jaime Gómez Vega"
      }
    },
    "notary": {
      "checks": {
        "check_dni": "true",
        "check_nombre": "true",
        "check_protocolo": "false",
        "check_total": "true"
      },
      "extraido": {
        "cliente": {
          "dni": "27310909L",
          "nombre": "Jaime Gómez Vega"
        },
        "notario": {
          "nombre": "AGUEL ANGEL FERNANDEZ LOPEZ",
          "notaria": "SEVILLA"
        },
        "protocolo": "303 0688",
        "total_factura": "480.75"
      },
      "recibido": {
        "client_dni": "27310909L",
        "client_name": "Jaime Gómez Vega",
        "notary_total_amount": "480.75",
        "protocol": "688"
      }
    },
    "registry": {
      "checks": {
        "check_amount": "true",
        "check_nombre": "true",
        "check_protocolo": "No disponible"
      },
      "extraido": {
        "client_name": "Jaime Gomez Vega",
        "protocolo": "No disponible",
        "registration_amount": "90.91"
      },
      "recibido": {
        "client_name": "Jaime Gómez Vega",
        "protocol": "688",
        "registration_amount": "90.91"
      }
    }
  },
  "status": "Procesado sin escritura hipotecaria",
  "validation_summary": {
    "agency": {
      "checks": {
        "amount": {
          "actual": "419.99",
          "expected": "209.99",
          "status": "error"
        },
        "nombre": {
          "actual": "Jaime Gomez Vega",
          "expected": "Jaime Gómez Vega",
          "status": "success"
        },
        "protocolo": {
          "actual": "No disponible",
          "expected": "688",
          "status": "unavailable"
        }
      },
      "status": "error"
    },
    "appraisal": {
      "checks": {
        "amount": {
          "actual": "214.99",
          "expected": "214.99",
          "status": "success"
        },
        "nombre": {
          "actual": "Jaime Gómez Vega",
          "expected": "Jaime Gómez Vega",
          "status": "success"
        },
        "protocolo": {
          "actual": "No disponible",
          "expected": "688",
          "status": "unavailable"
        }
      },
      "status": "partial"
    },
    "dni": {
      "checks": {
        "dni": {
          "actual": "27310909L",
          "expected": "27310909L",
          "status": "success"
        },
        "dni_valido": {
          "actual": "true",
          "expected": "true",
          "status": "success"
        },
        "nombre": {
          "actual": "Jaime Gomez Vega",
          "expected": "Jaime Gómez Vega",
          "status": "success"
        }
      },
      "status": "success"
    },
    "notary": {
      "checks": {
        "dni": {
          "actual": "27310909L",
          "expected": "27310909L",
          "status": "success"
        },
        "nombre": {
          "actual": "Jaime Gómez Vega",
          "expected": "Jaime Gómez Vega",
          "status": "success"
        },
        "protocolo": {
          "actual": "303 0688",
          "expected": "688",
          "status": "error"
        },
        "total": {
          "actual": "480.75",
          "expected": "480.75",
          "status": "success"
        }
      },
      "status": "error"
    },
    "registry": {
      "checks": {
        "amount": {
          "actual": "90.91",
          "expected": "90.91",
          "status": "success"
        },
        "nombre": {
          "actual": "Jaime Gomez Vega",
          "expected": "Jaime Gómez Vega",
          "status": "success"
        },
        "protocolo": {
          "actual": "No disponible",
          "expected": "688",
          "status": "unavailable"
        }
      },
      "status": "partial"
    }
  },
  "warnings": [
    "No se ha proporcionado la escritura hipotecaria. No se pueden validar los datos personales."
  ]
};

const DocumentUploadForm = ({
  autoFill,
  setAutoFill,
  negocioData,
  onValidationComplete,
  initialDocuments = {
    notary: null,
    registry: null,
    appraisal: null,
    agency: null,
    dni: null,
    mortgage_deed: null
  }
}) => {
  const { t } = useTranslation();
  const [hasAdditionalPerson, setHasAdditionalPerson] = useState(false);
  const [hasAdditionalDocs, setHasAdditionalDocs] = useState(false);

  const [files, setFiles] = useState({
    // Documentos principales
    claim: null,
    notary: null,
    registry: null,
    appraisal: null,
    agency: null,
    // Persona principal
    dni: null,
    // Persona adicional
    dni_2: null,
    // Escritura
    mortgage_deed: null,
    // Documentos adicionales
    notary_2: null,
    registry_2: null,
    appraisal_2: null,
    agency_2: null,
  });

  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [validationResults, setValidationResults] = useState(null);
  const [correctedData, setCorrectedData] = useState({});

  // Estado para drag and drop
  const [dragActive, setDragActive] = useState({});
  // Estado para mostrar advertencia de PDF no permitido
  const [pdfWarning, setPdfWarning] = useState({});

  const convertBaserowDocumentToFile = async (documentArray) => {
    if (!documentArray?.length) return null;

    try {
      const [doc] = documentArray;
      const response = await fetch(doc.url);
      if (!response.ok) throw new Error('Error al obtener el documento');

      const blob = await response.blob();
      return new File([blob], doc.visible_name, { type: doc.mime_type });
    } catch (error) {
      console.error('Error convirtiendo documento:', error);
      return null;
    }
  };

  useEffect(() => {
    const loadInitialDocuments = async () => {
      try {
        const documentMapping = {
          'Documento Notaría': 'notary',
          'Documento Registro': 'registry',
          'Documento Tasación': 'appraisal',
          'Documento Gestoría': 'agency',
          'Documento DNI': 'dni',
          'Documento DNI Adicional': 'dni_2',
          'Documento Escritura Hipotecaria': 'mortgage_deed',
          'Documento Notaría Adicional': 'notary_2',
          'Documento Registro Adicional': 'registry_2',
          'Documento Tasación Adicional': 'appraisal_2',
          'Documento Gestoría Adicional': 'agency_2'
        };

        const loadedFiles = Object.entries(documentMapping).reduce(async (acc, [key, value]) => {
          const files = await acc;
          const convertedFile = await convertBaserowDocumentToFile(initialDocuments[key]);
          console.log(`Convertido ${key} a ${value}:`, convertedFile);
          files[value] = convertedFile;
          return files;
        }, Promise.resolve({
          claim: null,
          notary: null,
          registry: null,
          appraisal: null,
          agency: null,
          dni: null,
          dni_2: null,
          mortgage_deed: null,
          notary_2: null,
          registry_2: null,
          appraisal_2: null,
          agency_2: null,
        }));

        const finalFiles = await loadedFiles;
        console.log('Archivos finales:', finalFiles);
        setFiles(finalFiles);
      } catch (error) {
        console.error('Error cargando documentos:', error);
        setError('Error al cargar los documentos iniciales');
      }
    };

    loadInitialDocuments();
  }, [initialDocuments]);

  const documentTypes = {
    // Documentos principales
    claim: {
      name: t('Reclamación de Gastos'),
      required: true
    },
    notary: {
      name: t('Factura Notaría'),
      required: false
    },
    registry: {
      name: t('Factura Registro'),
      required: false
    },
    appraisal: {
      name: t('Factura Tasación'),
      required: false
    },
    agency: {
      name: t('Factura Gestoría'),
      required: false
    },
    // Primera persona
    dni: {
      name: t('DNI Frontal - Persona 1'),
      required: false,
      group: 'dni'
    },
    // Segunda persona
    dni_2: {
      name: t('DNI Frontal - Persona 2'),
      required: false,
      condition: hasAdditionalPerson,
      group: 'dni'
    },
    // Escritura
    mortgage_deed: {
      name: t('Escritura Hipotecaria'),
      required: false
    },
    // Documentos adicionales
    notary_2: {
      name: t('Factura Notaría (Adicional)'),
      required: false,
      condition: hasAdditionalDocs
    },
    registry_2: {
      name: t('Factura Registro (Adicional)'),
      required: false,
      condition: hasAdditionalDocs
    },
    appraisal_2: {
      name: t('Factura Tasación (Adicional)'),
      required: false,
      condition: hasAdditionalDocs
    },
    agency_2: {
      name: t('Factura Gestoría (Adicional)'),
      required: false,
      condition: hasAdditionalDocs
    },
  };

  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    // Solo permitir PDF en claim y mortgage_deed
    const isPDF = file && file.type === 'application/pdf';
    if (isPDF && type !== 'claim' && type !== 'mortgage_deed') {
      setPdfWarning(prev => ({ ...prev, [type]: true }));
      setFiles(prev => ({ ...prev, [type]: null }));
      setError(null);
      return;
    } else {
      setPdfWarning(prev => ({ ...prev, [type]: false }));
    }
    setFiles(prev => ({
      ...prev,
      [type]: file
    }));
    setError(null);
  };

  // Nuevo: función para borrar archivo
  const handleRemoveFile = (type) => {
    setFiles(prev => ({
      ...prev,
      [type]: null
    }));
    setPdfWarning(prev => ({ ...prev, [type]: false }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!files.claim) {
      setError(t('La reclamación de gastos es obligatoria'));
      return;
    }

    setUploading(true);
    setError(null);
    setValidationResults(null);

    const formData = new FormData();

    // Filtrar archivos según los toggles
    const filteredFiles = { ...files };
    if (!hasAdditionalPerson) {
      filteredFiles.dni_2 = null;
    }
    if (!hasAdditionalDocs) {
      filteredFiles.notary_2 = null;
      filteredFiles.registry_2 = null;
      filteredFiles.appraisal_2 = null;
      filteredFiles.agency_2 = null;
    }

    Object.entries(filteredFiles).forEach(([key, file]) => {
      if (file) {
        formData.append(key, file);
      }
    });
    
    // Añadir información sobre la configuración
    formData.append('hasAdditionalPerson', hasAdditionalPerson);
    formData.append('hasAdditionalDocs', hasAdditionalDocs);

    // Añadir negocioData[1] sin la clave de la ID
    if (negocioData && negocioData[1]) {
      const values = Object.values(negocioData[1]);
      if (values.length > 0) {
        formData.append('negocio_data', JSON.stringify(values[0]));
      }
    }

    try {
      const supabaseClient = createClient(
        'https://uoclqlfzojdjrhcqhgef.supabase.co',
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVvY2xxbGZ6b2pkanJoY3FoZ2VmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTc3MDEzMDMsImV4cCI6MjAxMzI3NzMwM30.6VY6hK2MWHngYFt3AP9MkV_1hC0xOIuX0CbYIsC5DT0'
      );
      const { data } = await supabaseClient.auth.getSession();
      const access_token = data.session.access_token;

      const response = await axios({
        method: 'post',
        url: 'https://api.office.coventia.es/ai/upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': access_token
        },
        withCredentials: false
      });

      // Añadir validation_summary a setValidationResults
      setValidationResults(response.data.validation_summary);

      if (onValidationComplete) {
        onValidationComplete({
          ...response.data,
          config: {
            hasAdditionalPerson,
            hasAdditionalDocs
          }
        });
      }

      // Añadir de la respuesta del backend sobre mortgage_deed el clause_text al autofill de clausula_texto dentro de expense_Docs
      if (response.data.expense_docs && response.data.expense_docs.mortgage_deed && response.data.expense_docs.mortgage_deed.clause_text) {
        const clauseText = response.data.expense_docs.mortgage_deed.clause_text;
        setAutoFill({ ...autoFill, clausula_texto_gastos: clauseText });
      }

    } catch (error) {
      console.error('Error completo:', error);
      setError(error.response?.data?.message || t('Error al procesar los documentos', { error }));
    } finally {
      setUploading(false);
    }
  };

  const handleCorrection = (correction) => {
    const { docType, checkType, value, updatedDocValidation } = correction;

    setCorrectedData(prev => ({
      ...prev,
      [docType]: {
        ...prev[docType],
        [checkType]: value
      }
    }));

    const newValidationResults = {
      ...validationResults,
      [docType]: updatedDocValidation
    };

    setValidationResults(newValidationResults);

    onValidationComplete?.({
      validation_summary: newValidationResults,
      corrected_data: {
        ...correctedData,
        [docType]: {
          ...correctedData[docType],
          [checkType]: value
        }
      },
      config: {
        hasAdditionalPerson,
        hasAdditionalDocs
      }
    });
  };

  const handleMockData = () => {
    const mockResults = mockValidationData.validation_summary;
    setValidationResults(mockResults);
    if (onValidationComplete) {
      onValidationComplete({
        validation_summary: mockResults,
        corrected_data: correctedData,
        config: {
          hasAdditionalPerson,
          hasAdditionalDocs
        }
      });
    }
  };

  const resetForm = () => {
    setFiles({
      claim: null,
      notary: null,
      registry: null,
      appraisal: null,
      agency: null,
      dni: null,
      dni_2: null,
      mortgage_deed: null,
      notary_2: null,
      registry_2: null,
      appraisal_2: null,
      agency_2: null,
    });
    setValidationResults(null);
    setError(null);
    setHasAdditionalPerson(false);
    setHasAdditionalDocs(false);
  };

  const renderFileInput = (type) => {
    const { name, required, condition } = documentTypes[type];
    // No renderizar el input si la condición es falsa
    if (condition === false) return null;
    const file = files[type];
    const isDragActive = !!dragActive[type];
    // Definir el accept según el tipo
    const accept = (type === 'claim' || type === 'mortgage_deed') ? '.pdf' : '.jpg,.jpeg,.png';
    // Handlers de drag and drop
    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive((prev) => ({ ...prev, [type]: true }));
    };
    const handleDragEnter = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive((prev) => ({ ...prev, [type]: true }));
    };
    const handleDragLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive((prev) => ({ ...prev, [type]: false }));
    };
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive((prev) => ({ ...prev, [type]: false }));
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        handleFileChange(type, { target: { files: e.dataTransfer.files } });
      }
    };
    return (
      <motion.div
        className="mb-4 min-w-0"
        variants={fadeInUp}
        initial="hidden"
        animate="visible"
        exit="hidden"
        transition={{ duration: 0.3 }}
      >
        <div className="flex justify-between items-center mb-2 min-w-0">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
            {name} {required && <span className="text-rose-500">*</span>}
          </label>
          <div className="flex items-center gap-2 min-w-0">
            <AnimatePresence mode="wait">
              {file && (
                <motion.span
                  className="text-sm text-emerald-600 dark:text-emerald-400 flex items-center max-w-[180px] truncate whitespace-nowrap overflow-hidden text-ellipsis"
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 10 }}
                  transition={{ duration: 0.2 }}
                  title={file.name}
                >
                  <FaCheck className="mr-1" /> {file.name}
                </motion.span>
              )}
            </AnimatePresence>
            {/* Botón para borrar archivo */}
            {file && (
              <button
                type="button"
                onClick={() => handleRemoveFile(type)}
                className="ml-1 px-2 py-0.5 text-xs rounded bg-rose-100 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 hover:bg-rose-200 dark:hover:bg-rose-900/40 transition-colors"
                title={t('Quitar archivo')}
              >
                {t('Quitar')}
              </button>
            )}
          </div>
        </div>
        {/* Advertencia si se intenta subir un PDF en un campo no permitido */}
        {pdfWarning[type] && (
          <div className="mb-2 p-2 rounded bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200 text-xs border border-yellow-300 dark:border-yellow-700">
            {t('No se pueden procesar archivos PDF en este campo. Solo se permiten imágenes (.jpg, .jpeg, .png).')}
          </div>
        )}
        <div
          className={`relative ${isDragActive ? 'ring-2 ring-blue-400 border-blue-400 bg-blue-50 dark:ring-blue-500/60 dark:bg-blue-900/30' : ''}`}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            type="file"
            onChange={(e) => handleFileChange(type, e)}
            className="hidden"
            id={`file-${type}`}
            accept={accept}
          />
          <motion.label
            whileTap={{ scale: 0.99 }}
            htmlFor={`file-${type}`}
            className={
              `flex items-center justify-center px-4 py-3 rounded-md border-2 border-dashed dark:bg-gray-900 ` +
              (file
                ? 'border-emerald-200 bg-emerald-50 dark:border-emerald-700 dark:bg-emerald-900/20'
                : isDragActive
                  ? 'border-blue-400 bg-blue-50 dark:border-blue-500/60 dark:bg-blue-900/30'
                  : 'border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500 dark:bg-gray-800 bg-white') +
              ' cursor-pointer transition-colors duration-200 w-full'
            }
          >
            <motion.div
              initial={{ rotate: 0 }}
              whileHover={{ rotate: [0, -10, 10, -5, 5, 0] }}
              transition={{ duration: 0.5 }}
            >
              <FaUpload className={`mr-2 ${file
                ? 'text-emerald-500 dark:text-emerald-400'
                : isDragActive
                  ? 'text-blue-500 dark:text-blue-400'
                  : 'text-gray-400 dark:text-gray-500'
                }`} />
            </motion.div>
            <span className="text-sm text-gray-600 dark:text-gray-300 truncate">
              {isDragActive
                ? t('Suelta el archivo aquí')
                : file
                  ? t('Cambiar archivo')
                  : (type === 'claim' || type === 'mortgage_deed')
                    ? t('Seleccione o arrastre un archivo PDF')
                    : t('Seleccione o arrastre una imagen (.jpg, .jpeg, .png)')}
            </span>
          </motion.label>
        </div>
      </motion.div>
    );
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-8">
      <AnimatePresence mode="wait">
        {!validationResults ? (
          <motion.div
            key="form"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
          >
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
                {t('Subir Documentos')}
              </h2>
              <button
                onClick={handleMockData}
                className="flex items-center px-3 py-1 text-sm text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                title={t('Cargar datos de prueba')}
              >
                <BsLightningCharge className="mr-1" />
                Test
              </button>
            </div>

            <form onSubmit={handleSubmit} className="w-full bg-white dark:bg-gray-800 rounded-lg shadow dark:shadow-gray-900/20 border border-gray-200 dark:border-gray-700 p-6 mt-6">
              <motion.div
                className="flex flex-wrap gap-4 mb-8"
                variants={staggerContainer}
                initial="hidden"
                animate="visible"
                transition={{ staggerChildren: 0.1 }}
              >
                <motion.button
                  variants={buttonVariants}
                  whileHover="hover"
                  whileTap="tap"
                  type="button"
                  onClick={() => setHasAdditionalPerson(!hasAdditionalPerson)}
                  className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-all duration-300 dark:bg-gray-900 ${hasAdditionalPerson
                      ? 'bg-primary-100 text-primary-800 dark:bg-primary-900/20 dark:text-primary-300 shadow-sm'
                      : 'bg-gray-100 text-gray-800 dark:bg-gray-700/50 dark:text-gray-300'
                    }`}
                >
                  <motion.div
                    animate={{ scale: hasAdditionalPerson ? [1, 1.5, 1] : 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                  >
                    <FaUserPlus className="mr-2" />
                  </motion.div>
                  {hasAdditionalPerson ? t('Segunda persona añadida') : t('Añadir segunda persona')}
                </motion.button>

                <motion.button
                  variants={buttonVariants}
                  whileHover="hover"
                  whileTap="tap"
                  type="button"
                  onClick={() => setHasAdditionalDocs(!hasAdditionalDocs)}
                  className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-all duration-300 dark:bg-gray-900 ${hasAdditionalDocs
                      ? 'bg-primary-100 text-primary-800 dark:bg-primary-900/20 dark:text-primary-300 shadow-sm'
                      : 'bg-gray-100 text-gray-800 dark:bg-gray-700/50 dark:text-gray-300'
                    }`}
                >
                  <motion.div
                    animate={{ scale: hasAdditionalDocs ? [1, 1.5, 1] : 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                  >
                    <FaFileMedical className="mr-2" />
                  </motion.div>
                  {hasAdditionalDocs ? t('Documentos adicionales añadidos') : t('Añadir documentos adicionales')}
                </motion.button>
              </motion.div>

              <motion.div
                className="mb-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.3 }}
              >
                <motion.h3
                  className="text-lg font-semibold mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100"
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {t('Documento principal')}
                </motion.h3>
                {renderFileInput('claim')}
              </motion.div>

              <motion.div
                className="mb-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.15, duration: 0.3 }}
              >
                <motion.h3
                  className="text-lg font-semibold mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100"
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {t('Documentos de identidad')}
                </motion.h3>
                <motion.div
                  className="grid grid-cols-1 md:grid-cols-2 gap-6"
                  variants={staggerContainer}
                  initial="hidden"
                  animate="visible"
                >
                  {renderFileInput('dni')}
                  <AnimatePresence>
                    {hasAdditionalPerson && (
                      <>
                        <motion.div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.4 }}
                        >
                          {renderFileInput('dni_2')}
                        </motion.div>
                      </>
                    )}
                  </AnimatePresence>
                </motion.div>
              </motion.div>

              <motion.div
                className="mb-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.3 }}
              >
                <motion.h3
                  className="text-lg font-semibold mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100"
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {t('Documentos de facturas')}
                </motion.h3>
                <motion.div
                  className="grid grid-cols-1 md:grid-cols-2 gap-6 overflow-x-auto"
                  variants={staggerContainer}
                  initial="hidden"
                  animate="visible"
                >
                  {renderFileInput('notary')}
                  {renderFileInput('registry')}
                  {renderFileInput('appraisal')}
                  {renderFileInput('agency')}
                </motion.div>
              </motion.div>

              <AnimatePresence>
                {hasAdditionalDocs && (
                  <motion.div
                    className="mb-8"
                    initial={{ opacity: 0, height: 0, overflow: "hidden" }}
                    animate={{ opacity: 1, height: "auto", overflow: "visible" }}
                    exit={{ opacity: 0, height: 0, overflow: "hidden" }}
                    transition={{ duration: 0.5 }}
                  >
                    <motion.h3
                      className="text-lg font-semibold mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100"
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.3 }}
                    >
                      {t('Documentos adicionales')}
                    </motion.h3>
                    <motion.div
                      className="grid grid-cols-1 md:grid-cols-2 gap-6 overflow-x-auto"
                      variants={staggerContainer}
                      initial="hidden"
                      animate="visible"
                    >
                      {renderFileInput('notary_2')}
                      {renderFileInput('registry_2')}
                      {renderFileInput('appraisal_2')}
                      {renderFileInput('agency_2')}
                    </motion.div>
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.div
                className="mb-8"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.25, duration: 0.3 }}
              >
                <motion.h3
                  className="text-lg font-semibold mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-100"
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {t('Escritura hipotecaria')}
                </motion.h3>
                {renderFileInput('mortgage_deed')}
              </motion.div>

              <AnimatePresence>
                {error && (
                  <motion.div
                    className="mb-4 p-3 rounded bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-300 text-sm border border-rose-200 dark:border-rose-700"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}
                  >
                    {error}
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.button
                type="submit"
                disabled={uploading || !files.claim}
                className={`
                  w-full py-2 px-4 rounded-md text-white font-medium dark:bg-blue-500
                  ${uploading || !files.claim
                    ? 'bg-gray-400 dark:bg-gray-700 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600'
                  }
                  transition-colors duration-200
                `}
                whileHover={!uploading && files.claim ? { scale: 1.02 } : {}}
                whileTap={!uploading && files.claim ? { scale: 0.98 } : {}}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.3 }}
              >
                {uploading ? (
                  <motion.span
                    className="flex items-center justify-center"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div>
                      <FaSpinner className="mr-2 animate-spin" />
                    </div>
                    {t('Subiendo documentos...')}
                  </motion.span>
                ) : (
                  t('Validar Documentos')
                )}
              </motion.button>
            </form>
          </motion.div>
        ) : (
          <motion.div
            key="results"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="relative"
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
                {t('Resultados de la Validación')}
              </h2>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={resetForm}
                className="flex items-center px-4 py-2 text-sm font-medium text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                <FaArrowLeft className="mr-2" />
                {t('Volver a subir documentos')}
              </motion.button>
            </div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              <TableCheck
                validationSummary={validationResults}
                onCorrection={handleCorrection}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

//PropTypes
DocumentUploadForm.propTypes = {
  autoFill: PropTypes.object,
  setAutoFill: PropTypes.func,
  negocioData: PropTypes.array,
  onValidationComplete: PropTypes.func.isRequired,
  initialDocuments: PropTypes.object
};

export default DocumentUploadForm; 